import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { BehaviorSubject } from 'rxjs';
import { concatMap, first } from 'rxjs/operators';

import { Refreshable } from '../../../../../utils/refreshable.interface';
import { DashboardService } from '../../dashboard.service';
import it from './i18n/aggregated.it.json';

@Component({
  selector: 'app-aggregated',
  templateUrl: './aggregated.component.html',
  styleUrls: ['./aggregated.component.scss']
})
export class AggregatedComponent implements OnInit, Refreshable {

  private refresh$$ = new BehaviorSubject<void>(undefined);
  aggregated$ = this.refresh$$.pipe(
    concatMap(() => this.dashboardSvc.getAggregated().pipe(first()))
  );

  constructor(
    private dashboardSvc: DashboardService,
    private translocoSvc: TranslocoService,
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.refresh$$.next();
  }

}
